/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RecentButton_viewer = {
    readonly id: string;
    readonly backendId: number | null;
    readonly " $refType": "RecentButton_viewer";
};
export type RecentButton_viewer$data = RecentButton_viewer;
export type RecentButton_viewer$key = {
    readonly " $data"?: RecentButton_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RecentButton_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecentButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'd4a40b06261a8d0ccdab09d4da598c00';
export default node;
